export { default } from "./PageContentSkeleton";
